<template>
    <div>
        <!-- <div v-for="(item, index) in salepages.sale_page_detail" :key="index"> -->
            <sectionHeader v-if="salepage.section_type === 'header'" :item="salepage"/>

            <sectionBanner v-if="salepage.section_type === 'banner'" :item="salepage"/>

            <sectionBenefits v-if="salepage.section_type === 'benefits'" :item="salepage"/>

            <sectionFeature v-if="salepage.section_type === 'feature'" :item="salepage"/>

            <sectionEmbed v-if="salepage.section_type === 'embed'" :item="salepage"/>

            <sectionBannerImage v-if="salepage.section_type === 'bannerimage'" :item="salepage"/>

            <!-- <div v-if="item.section_type === 'header'">
        <header class="site-header" id="masthead">
          <div class="container">
            <div class="grid">
              <div class="col-1-1">
                <div class="site-header-top">
                  <div class="row">
                    <div class="site-logo">
                      <a href="https://insure.724.co.th/" rel="home" itemprop="url">
                        <div class="logo--market" itemprop="logo">724 Market</div>
                      </a>
                    </div>
                    <div class="site-logo-partner">
                      <picture>
                        <source
                          :srcset="currentUrl + '/img/sale_page_single/' + item.section_value.header_photo_one"
                          media="(min-width: 375px)"
                        />
                        <source
                          srcset="uploads/site-logo-partner-380x108.png"
                          media="(min-width: 320px)"
                        >
                        <img :src="currentUrl + '/img/sale_page_single/' + item.section_value.header_photo_one" />
                      </picture>
                    </div>
                    <div class="site-logo-partner">
                      <div class="figure">
                        <img :src="currentUrl + '/img/sale_page_single/' + item.section_value.header_photo_one" />
                      </div>
                    </div>
                    <div class="site-meta">
                      <button class="btn btn--square showAccount" @click="shareButton()">
                        Share
                        <i class="fas fa-share-alt"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-1-1">
                <div class="site-header-below header-bg-color header-bg">
                  <div class="call-center">
                    <h6>ศูนย์บริการลูกค้า</h6>
                    <a class="telephone" :href="'tel:' + salepages.sale_page.service_call">
                      {{ salepages.sale_page.service_call }}
                    </a>
                  </div>
                  <div class="counsel-right">
                    <button @click="showCallback()" class="btn btn--contact btn--square btncall">
                      {{ salepages.sale_page.button_title }}
                    </button>
                    <button class="btn--square btn--share showAccount" @click="shareButton()">
                      Share
                      <i class="fas fa-share-alt"></i>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </header>
            </div>-->
            <!-- <div v-if="item.section_type === 'banner'">
        <div class="site-banner">
          <div class="banner-major">
            <div
              class="site-image-desktop"
              :style="{
                'background-image':
                  'url(' + currentUrl + '/img/sale_page_single/' + item.section_value.banner_background + ')'
              }"
            ></div>
            <div class="container">
              <div class="site-banner-picture">
                <picture>
                  <source
                    :srcset="currentUrl + '/img/sale_page_single/' + item.section_value.banner_background"
                    media="(min-width: 1000px)"
                  />
                  <source srcset="uploads/vcare-total-mobile.jpg" media="(min-width: 320px)">
                  <img src="uploads/20190424173203.jpg" />
                </picture>
              </div>
              <div class="site-banner-product">
                <div class="site-banner-detail">
                  <div class="detail-box-left">
                    <h3 v-text="item.section_value.banner_title" />
                    <h5 v-text="item.section_value.banner_subtitle" />
                  </div>
                  <div class="detail-box-right">
                    <button
                      @click="BannerDownloadFile(item.sale_page_section_id)"
                      class="btn--download btn--square btn--full"
                    >
                      ดาวน์โหลดแผน
                    </button>
                    <p v-html="item.section_value.banner_text_center" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
            </div>-->
            <!-- <div v-if="item.section_type === 'benefits'">
        <div class="site-benefits">
          <div class="container">
            <div
              class="grid benefits-bg"
              :style="{
                'background-image':
                  'url(' + currentUrl + '/img/sale_page_single/' + item.section_value.benefits_photo + ')'
              }"
            >
              <div class="benefits-media">
                <img :src="currentUrl + '/img/sale_page_single/' + item.section_value.benefits_photo" />
              </div>
              <div class="benefits-detail">
                <div v-html="item.section_value.benefits_text"></div>
              </div>
            </div>
          </div>
        </div>
            </div>-->
            <!-- <div v-if="item.section_type === 'feature'">
        <div class="site-feature">
          <div class="container">
            <div :class="item.section_value.length % 3 == 0 ? 'site-feature-style1' : 'site-feature-style2'">
              <div
                class="site-feature-item"
                v-for="(itemFeature, indexFeature) in item.section_value"
                :key="indexFeature"
              >
                <div class="feature-media">
                  <div class="media-size">
                    <img :src="currentUrl + '/img/sale_page_single/' + itemFeature.photo" />
                    <div class="icon-top-right icon-top-right-color">
                      <i class="icon-top-right-font fas fa-check"></i>
                    </div>
                  </div>
                </div>
                <div class="feature-topic" v-html="itemFeature.detail"></div>
              </div>
            </div>
          </div>
        </div>
            </div>-->
            <!-- <div v-if="item.section_type === 'embed'">
        <div class="container">
          <div class="site-media">
            <div class="media-embed">
              <iframe
                width="560"
                height="315"
                :src="item.section_value.embed_text"
                frameborder="0"
                allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
                allowfullscreen
              ></iframe>
            </div>
          </div>
        </div>
            </div>-->
        <!-- </div> -->
        <!-- <sectionTestimonial :items="salepages"/> -->
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import sectionHeader from '@/components/List/sectionHeader'
import sectionBanner from '@/components/List/sectionBanner'
import sectionBenefits from '@/components/List/sectionBenefits'
import sectionFeature from '@/components/List/sectionFeature'
import sectionEmbed from '@/components/List/sectionEmbed'
import sectionTestimonial from '@/components/List/sectionTestimonial'

import sectionBannerImage from '@/components/List/sectionBannerImage'

export default {
  props: {
    salepage: {
      type: Object
    },
  },
    components: {
        sectionHeader,
        sectionBanner,
        sectionBenefits,
        sectionFeature,
        sectionEmbed,
        sectionTestimonial,
        sectionBannerImage
    },
    data() {
        return {
            //currentUrl: window.location.protocol + '//' + window.location.host + '/'
        }
    },
    computed: {
        //...mapState({ currentUrl: state => state.currentUrl }),
        //...mapState({ salepages: state => state.salepage })
    },
    methods: {
        
        
        // shareButton() {
        //     showAccount.show()
        // },
        // showCallback() {
        //     showCallback.show()
        // }
    },
    async mounted() {
        
    },
}

// var showAccount = $('#modal-share')
//     .mobiscroll()
//     .popup({
//         display: 'center',
//         buttons: [],
//         layout: 'liquid'
//     })
//     .mobiscroll('getInst')

// var showCallback = $('#modal-callback')
//     .mobiscroll()
//     .popup({
//         display: 'center',
//         buttons: [],
//         layout: 'liquid'
//     })
//     .mobiscroll('getInst')

// $('#showCallback').click(function () {
//     showCallback.show();
//     return false;
//   });
</script>

<style scoped>
</style>